import styled from 'styled-components';
import { Sizes } from '../../utils/sizes';
import { Colors } from '../../utils/colors';

export const PaymentOptionsStyle = styled.div`
  box-sizing: border-box;
  width: 100%;

  & .payment-methods {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      grid-template-columns: 1fr;
    }
  }

  & .payment-method {
    padding: 20px;
    border: 2px solid ${Colors.gold};
    border-radius: 8px;
    background: rgba(20, 20, 20, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      background: rgba(255, 193, 13, 0.04);
      box-shadow: none;
      border-color: rgba(255, 193, 13, 0.15);
    }

    &.active {
      background: rgba(255, 193, 13, 0.06);
      box-shadow: none;
      border-color: ${Colors.yellow};

      & .method-header {
        color: ${Colors.yellow};
      }
    }

    & .method-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 10px;
      color: ${Colors.white};
      font-weight: 500;
      transition: color 0.3s ease;

      & .icon {
        font-size: 24px;
      }
    }

    & .method-badge {
      position: absolute;
      top: -10px;
      right: 20px;
      background: ${Colors.yellow};
      color: ${Colors.dark};
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 11px;
      font-weight: bold;
    }

    & .method-description {
      color: ${Colors.gold};
      font-size: 12px;
      line-height: 1.4;
    }
  }

  & .payment-form {
    background: rgba(20, 20, 20, 0.5);
    border: 1px solid ${Colors.gold};
    border-radius: 8px;
    padding: 25px;
    margin-bottom: 20px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 18px;
    }

    & h4 {
      color: ${Colors.yellow};
      font-size: 16px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  & .form-group {
    margin-bottom: 15px;

    & label {
      display: block;
      color: ${Colors.white};
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 6px;
      text-transform: uppercase;
    }

    & input,
    & select {
      width: 100%;
      padding: 14px 16px;
      background: rgba(255, 255, 255, 0.05);
      border: 2px solid ${Colors.gold};
      border-radius: 6px;
      color: ${Colors.white};
      font-size: 15px;
      font-weight: 500;
      transition: all 0.3s ease;
      min-height: 48px;
      appearance: none;
      cursor: pointer;
      position: relative;
      z-index: 10;

      &:focus {
        outline: none;
        background: rgba(255, 255, 255, 0.08);
        border-color: ${Colors.yellow};
        box-shadow: 0 0 8px rgba(255, 215, 0, 0.2);
      }

      &:hover {
        border-color: rgba(255, 215, 0, 0.6);
      }

      &::placeholder {
        color: ${Colors.gold};
      }
    }

    /* Secure Fields (iframes do Mercado Pago) — aparência de input. */
    & .mp-secure-field {
      width: 100%;
      padding: 14px 16px;
      background: rgba(255, 255, 255, 0.05);
      border: 2px solid ${Colors.gold};
      border-radius: 6px;
      min-height: 48px;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      position: relative;
      z-index: 10;
    }
    & .mp-secure-field iframe {
      width: 100%;
      height: 20px;
      border: 0;
      display: block;
    }

    & select option {
      background: ${Colors.dark};
      color: ${Colors.white};
      padding: 12px;
      font-size: 14px;
    }

    & select {
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffd700' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right 12px center;
      background-size: 20px;
      padding-right: 40px;
    }

    & input[type='checkbox'],
    & input[type='radio'] {
      width: auto;
      margin-right: 8px;
      cursor: pointer;
    }
  }

  & .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      grid-template-columns: 1fr;
    }
  }

  & .qr-code-container {
    box-sizing: border-box;
    text-align: center;
    padding: 22px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid ${Colors.gold};
    border-radius: 8px;
    margin: 14px 0;
    max-width: 100%;
    overflow: hidden;

    & .qr-code-title {
      color: ${Colors.yellow};
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
    }

    & img {
      display: block;
      margin: 0 auto;
      max-width: 260px;
      width: 100%;
      height: auto;
      border: 2px solid ${Colors.gold};
      border-radius: 8px;
      padding: 6px;
      background: white;
    }

    & .qr-svg {
      display: block;
      margin: 0 auto;
      max-width: 180px;
      width: 100%;
      height: auto;
      border: 2px solid ${Colors.gold};
      border-radius: 8px;
      padding: 6px;
      background: white;
    }

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 12px;
      & img { max-width: 220px; }
    }

    & .copy-code {
      margin-top: 15px;

      & .code-label {
        color: ${Colors.gold};
        font-size: 11px;
        margin-bottom: 8px;
      }

      & .code-box {
        display: flex;
        gap: 8px;
        align-items: center;

        & input {
          flex: 1;
          padding: 10px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid ${Colors.gold};
          border-radius: 6px;
          color: ${Colors.white};
          font-size: 11px;
          word-break: break-all;
          font-family: monospace;
        }

        & button {
          padding: 10px 16px;
          background: ${Colors.yellow};
          color: ${Colors.dark};
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          transition: all 0.3s ease;

          &:hover {
            background: ${Colors.gold};
          }
        }
      }
    }
  }

  & .payment-status {
    margin-top: 20px;
    padding: 15px;
    border-radius: 6px;
    font-size: 13px;
    text-align: center;

    &.loading {
      background: rgba(59, 130, 246, 0.1);
      border: 1px solid #3b82f6;
      color: #3b82f6;
    }

    &.success {
      background: rgba(34, 197, 94, 0.1);
      border: 1px solid #22c55e;
      color: #22c55e;
    }

    &.error {
      background: rgba(239, 68, 68, 0.1);
      border: 1px solid #ef4444;
      color: #ef4444;
    }
  }

  & .copy-notification {
    position: fixed;
    bottom: 30px;
    right: 30px;
    background: linear-gradient(135deg, ${Colors.yellow} 0%, ${Colors.gold} 100%);
    color: ${Colors.dark};
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(255, 215, 0, 0.3);
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    animation: slideInUp 0.3s ease-out;
    z-index: 9999;

    & .icon {
      font-size: 18px;
    }

    @keyframes slideInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      bottom: 20px;
      right: 20px;
      left: 20px;
      justify-content: center;
    }
  }

  /* ===== Modal do formulário de pagamento ===== */
  & .pay-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.72);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 16px;
    overflow-y: auto;
    z-index: 10000;
    animation: pay-fade 0.2s ease-out;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 20px 12px;
      align-items: stretch;
    }
  }

  & .pay-modal {
    position: relative;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    background: #141414;
    border: 1px solid rgba(255, 215, 0, 0.3);
    border-radius: 14px;
    padding: 26px 22px 22px;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
    animation: pay-pop 0.22s ease-out;
  }

  /* Dentro do modal, o formulário não precisa da própria moldura */
  & .pay-modal .payment-form {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin: 0;
  }

  & .pay-modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    background: transparent;
    border: none;
    color: #aaa;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    display: inline-flex;
    z-index: 1;

    &:hover { color: ${Colors.yellow}; }
  }

  @keyframes pay-fade {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes pay-pop {
    from { opacity: 0; transform: translateY(12px) scale(0.98); }
    to { opacity: 1; transform: none; }
  }
`;
